import {IntegerParameter} from "parameters/AbstractParameter.js";
import {saveParameterToJson, loadParameterFromJson} from "parameters/parameterJsonFunctions.js";
import {bulkUpdate} from "utils/bulkUpdate.js";

export default superclass => class extends superclass  {
    initValueParameter(min=-1, max=13, defaultValue=0) {
        this.valueParameter = new IntegerParameter(
            'value',
            this,
            () => 0,
            {
                min,
                max,
                defaultValue
            }
        );
        this.registerParameter(this.valueParameter);
    }

    get value() {
        return this.valueParameter.get();
    }

    set value(x) {
        this.valueParameter.set(x, false, false);
    }

    fromValueJson(json) {
        let bulk = {};
        bulkUpdate(this.valueParameter, json.value, bulk);

        return {
            ... bulk,
            ... loadParameterFromJson(json, 'valueParameter', this.valueParameter)
        };
    }

    getValueJson() {
        let json = {
            value: this.value
        };
        
        json = saveParameterToJson(json, 'valueParameter', this.valueParameter);
        return json;
    }
}
